import React from 'react'
import { Column } from 'react-table'
import Table from './Table'

const TableSkeleton: React.FC<{ headers: string[] }> = ({ headers }) => {
  const columns = React.useMemo<Column<any>[]>(
    () =>
      headers.map((header) => ({
        Header: header,
        disableSortBy: true,
        accessor: () => <span className="block h-3 w-36 animate-pulse rounded bg-gray-200" />,
      })),

    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const data = new Array(6).fill('')

  return <Table columns={columns} data={data} />
}

export default TableSkeleton
